
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCreateEventRegistrationSelectedOptionDto } from '../models/work-create-event-registration-selected-option-dto';

export function getUpdateEventInvitationAdminDtoFormGroup() {
return new FormGroup({
    gender: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    company: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    comment: new FormControl<string | undefined>(''),
    checkInAt: new FormControl<string | undefined>(undefined),
    eventRegistrationSelectedOptions: new FormControl<WorkCreateEventRegistrationSelectedOptionDto[]>([]),
})
;
}
      